import { useState, useRef } from "react";
import axios from "axios";
import { Check, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ASSET_ENDPOINTS = {
  thumbnail: "thumbnail",
  narrator: "narrator",
  narrator_track: "narrator",
  musicbed: "musicbed",
  music_bed: "musicbed",
  sfx: "sfx"
};

const AssetUploader = ({ episodeId, assetType, label, icon: Icon, currentUrl, onUploadComplete }) => {
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const endpoint = ASSET_ENDPOINTS[assetType] || assetType;
      const formData = new FormData();
      formData.append("file", file);
      await axios.post(`${API}/upload/${endpoint}/${episodeId}`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      onUploadComplete?.();
    } catch (error) {
      console.error("Upload failed:", error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex items-center gap-3 p-3 bg-white/5 rounded" data-testid={`upload-${assetType}-${episodeId}`}>
      <Icon size={18} className={currentUrl ? "text-green-500" : "text-gray-500"} />
      <span className="flex-1 text-sm">{label}</span>
      {currentUrl ? (
        <Check size={16} className="text-green-500" />
      ) : (
        <button
          onClick={() => fileRef.current?.click()}
          disabled={uploading}
          className="px-3 py-1 text-xs bg-red-600 hover:bg-red-700 rounded disabled:opacity-50"
          data-testid={`upload-btn-${assetType}-${episodeId}`}
        >
          {uploading ? <Loader2 size={12} className="animate-spin" /> : "Upload"}
        </button>
      )}
      <input
        ref={fileRef}
        type="file"
        accept={assetType === "thumbnail" ? "image/*" : "audio/*"}
        onChange={handleUpload}
        className="hidden"
      />
    </div>
  );
};

export default AssetUploader;
